import {
  Slider,
  SliderProps,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";

type SliderWithLabelProps = {
  label: string;
  labelFontSize?: string | number;
  markLabelFontSize?: string | number;
  markTooltip?: SliderProps["label"];
} & Omit<SliderProps, "label">;

export const SliderWithLabel = (props: SliderWithLabelProps) => {
  const {
    label,
    labelFontSize,
    markLabelFontSize,
    markTooltip = null,
    ...rest
  } = props;
  const theme = useMantineTheme();

  return (
    <Stack gap="xs">
      <Text
        sx={(_, u) => ({
          [u.dark]: {
            color: theme.colors.dark[0],
          },
          [u.light]: {
            color: "#495057",
          },
          fontSize: labelFontSize ?? "0.8em",
        })}
      >
        {label}
      </Text>
      <Slider
        mb="lg"
        thumbSize={18}
        size="xs"
        label={markTooltip}
        styles={(theme, _, u) => ({
          track: {
            "&:before": {
              [u.dark]: {
                backgroundColor: theme.colors.dark[1],
              },
              [u.light]: {
                backgroundColor: theme.colors.gray[5],
              },
            },
          },
          mark: {
            [u.dark]: {
              border: "none",
            },
            [u.light]: {
              border: "2px solid #7950f2",
            },
            width: "12px",
            height: "12px",
            position: "relative",
            left: "-3px",
            top: "-3px",
          },
          markLabel: {
            [u.dark]: {
              color: theme.colors.dark[0],
            },
            [u.light]: {
              color: "#495057",
            },
            fontSize: markLabelFontSize ?? "0.7em",
          },
        })}
        {...rest}
      />
    </Stack>
  );
};
